// Call Log Configuration types – mirrors backend CallLogDtos.cs

export const CALL_LOG_FORM_TYPE = 'CALL_LOG_FORM';

export interface CallLogConfigurationDto {
  enabled: boolean;
  allowCreate: boolean;
  allowEdit: boolean;
  allowDelete: boolean;
  /** Upper-cased entity types enabled for this program, e.g. ["PATIENT","HCP"] */
  enabledEntityTypes: string[];
  programFormId?: string | null;
  programFormName?: string | null;
  programFormCode?: string | null;
  programFormVersion?: number | null;
  /** true when a published CALL_LOG_FORM has been resolved for this program */
  formConfigured: boolean;
  requiredFormType: string;
}

export interface SaveCallLogConfigurationDto {
  enabled?: boolean | null;
  allowCreate?: boolean | null;
  allowEdit?: boolean | null;
  allowDelete?: boolean | null;
  enabledEntityTypes?: string[] | null;
  /** GUID of the published form to pin; omit to keep current */
  programFormId?: string | null;
  /** Set to true to remove the pinned form (falls back to auto-resolve) */
  clearProgramForm?: boolean;
}

export interface CallLogResolvedFormDto {
  programFormId: string;
  formName: string;
  formCode: string;
  formType?: string | null;
  version: number;
  status: string;
  /** JSON-serialised FormSchema */
  formSchema?: string | null;
}
